module.exports = __webpack_public_path__ + "img/bloomberg.4979eefc.svg";